import {
    createLazyComponent,
    LazyAction,
    type LazyComponent,
    LazyModule,
    registerLazyOrchestrator,
} from 'owa-bundling';
import type { CloudCacheAndEasidLinkProps } from './components/CloudCacheAndEasidLink';
import type * as lazyIndex from './lazyIndex';
import { getEasidLinkStore } from './store/store';
import { onCoprincipalBootStateChanged } from 'owa-account-source-list-store';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaCloudCacheLink" */ './lazyIndex'),
    { name: 'OwaCloudCacheLink' }
);

export const CloudCacheAndEasidLink: LazyComponent<CloudCacheAndEasidLinkProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CloudCacheAndEasidLink);

export const LinkWithEasidDialogLightning: LazyComponent<unknown, unknown, void> =
    createLazyComponent(lazyModule, m => m.LinkWithEasidDialogLightning, undefined, undefined, {
        onlyImportIf: () => !!getEasidLinkStore().accountToLink,
    });

export const lazyInitializeCloudCacheLinkStore: LazyAction<
    typeof lazyIndex.initializeCloudCacheLinkStore,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeCloudCacheLinkStore);

export const lazyInitializeCloudCacheLinkStoreAndDialog: LazyAction<
    typeof lazyIndex.initializeCloudCacheLinkStoreAndDialog,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.initializeCloudCacheLinkStoreAndDialog);

registerLazyOrchestrator(
    onCoprincipalBootStateChanged,
    lazyModule,
    m => m.onCoprincipalAccountAddedOrchestrator
);
